import { useQuery } from '@tanstack/react-query';
import {
  importCreatedSchema,
  importJobSchema,
  importListSchema,
  type ImportCreated,
  type ImportJob,
  type ImportRequest,
} from '@dishly/shared';
import { api } from './api.ts';

export const importKeys = { list: ['imports'] as const };

export const isActive = (job: ImportJob) => job.status !== 'done' && job.status !== 'failed';

/** Recent imports; polls every 2 s while one is running (online only). */
export function useImports(enabled = true) {
  return useQuery({
    queryKey: importKeys.list,
    queryFn: async () => importListSchema.parse(await api('/api/imports')).imports,
    enabled,
    refetchInterval: (query) => (query.state.data?.some(isActive) ? 2_000 : false),
  });
}

export async function startImport(request: ImportRequest): Promise<ImportCreated> {
  return importCreatedSchema.parse(
    await api('/api/imports', { method: 'POST', body: JSON.stringify(request) }),
  );
}

export async function retryImport(id: string): Promise<ImportJob> {
  return importJobSchema.parse(
    await api(`/api/imports/${id}/retry`, { method: 'POST', body: '{}' }),
  );
}
